import { goToPreviousPayload } from "~/events";
import { trackFbqEvent } from "~/events/fbqEventFactory";
import { trackersFactory } from "~/events/trackersFactory";

const trackers = trackersFactory("plan-select-page");

const extendToPlus = (): void => trackers({ action: "extend-to-plus-cta" });

const extendToPremium = (): void =>
  trackers({ action: "extend-to-premium-cta" });

const learnMoreAboutPlansLink = (): void =>
  trackers({ action: "learn-more-about-plans-link" });

const plusMembershipPlan = (): void => {
  trackers({ action: "plus-membership-plan-cta" });
  trackFbqEvent("InitiateCheckout", { content_ids: ["plus"] });
};

const premiumMembershipPlan = (): void => {
  trackers({ action: "premium-membership-plan-cta" });
  trackFbqEvent("InitiateCheckout", { content_ids: ["premium"] });
};

const resubscribeToPlus = (): void =>
  trackers({ action: "resubscribe-to-plus-cta" });

const resubscribeToPremium = (): void =>
  trackers({ action: "resubscribe-to-premium-cta" });

const upgradeToPremium = (): void => {
  trackers({ action: "upgrade-to-premium-cta" });
  trackFbqEvent("InitiateCheckout", { content_ids: ["premium-upgrade"] });
};

const goToPreviousPage = (): void => trackers(goToPreviousPayload);

export const trackPlanSelect = {
  extendToPremium,
  extendToPlus,
  goToPreviousPage,
  learnMoreAboutPlansLink,
  plusMembershipPlan,
  premiumMembershipPlan,
  resubscribeToPlus,
  resubscribeToPremium,
  upgradeToPremium,
};
